"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import { ReviewsType } from "commonModule/services/favorite/types";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const ReviewsModal = dynamic(() => import( /* webpackChunkName: "ReviewsModal" */"components/modals/ReviewsModal"), {
  ssr: false
});
const Reviews = (props: {
  ratingStarSum?: number | null;
  reviews: ReviewsType[];
  propertyId: string;
  propertyRatingUserCount?: number | null;
  ratingPercentages?: Partial<Record<number, number>> | null;
}) => {
  const {
    reviews,
    ratingStarSum,
    propertyId,
    propertyRatingUserCount,
    ratingPercentages
  } = props;
  const [isLargerThan768] = useMediaQuery("(min-width: 769px)");
  const [expandedReviews, setExpandedReviews] = useState<{
    [key: number]: boolean;
  }>({});

  // Set the length limit based on screen width
  const maxLength = isLargerThan768 ? 230 : 200;
  return <>
      <div className='pt-8'>
        <div className='hideScrollBar flex snap-x snap-mandatory grid-cols-1 gap-4 overflow-x-auto mxd:grid mxd:grid-cols-2 mxd:gap-6 mxd:gap-x-16 mxd:overflow-x-visible'>
          {reviews && reviews.slice(0, 4).map((review, idx) => {
          const isExpanded = expandedReviews[idx];
          const hasLongContent = (review?.comment?.trim()?.length || 0) > maxLength || (review?.response?.length || 0) > 0;
          return <div key={idx} className='mxd:min-w-auto mb-1 min-w-[75%] pr-[18px] ssm2:pr-[30px] mxd:pr-0 xll2:pr-2.5'>
                  <div className='mb-2 flex items-center gap-1 mxd:gap-2'>
                    <div className='flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full bg-accent-500 text-base font-semibold text-white'>
                      {review?.reviewer_name?.charAt(0)?.toUpperCase() || "A"}
                    </div>
                    <p className='text-sm font-semibold'>
                      {review.reviewer_name?.trim() || "Anonymous Traveler"}
                    </p>
                  </div>
                  <p className='mb-1 text-sm font-medium'>{review.title}</p>

                  <div className='mb-0.5 flex items-center gap-2.5'>
                    {review.created_dt && <p className='text-xs text-[#757474]'>
                        {new Date(review.created_dt).toLocaleDateString("en-US", {
                  timeZone: "UTC",
                  year: "numeric",
                  month: "long"
                })}
                      </p>}
                  </div>

                  <p dangerouslySetInnerHTML={{
              __html: review?.comment
            }} className={`defaultStyleSheet text-xs font-medium leading-[1.7] text-grayText mxd:text-sm mxd:leading-6 ${!isExpanded ? "line-clamp-6 mxd:line-clamp-4" : ""}`} />
                  {isExpanded && review?.response?.map((res, index) => <div key={index} className='mt-2 pl-7'>
                        <p className='text-sm font-semibold leading-6'>
                          Response from Host
                        </p>
                        {res?.response_date && <p className='text-sm leading-5'>
                            {new Date(res.response_date).toLocaleDateString("en-US", {
                  timeZone: "UTC",
                  year: "numeric",
                  month: "long"
                })}
                          </p>}
                        <p dangerouslySetInnerHTML={{
                __html: res?.message
              }} className='defaultStyleSheet mt-2 overflow-hidden text-sm font-medium leading-6 text-grayText' />
                      </div>)}

                  {/* Show more / less button */}
                  {hasLongContent && <button type='button' className='mt-1 h-6 bg-white p-0 text-xs text-textColor underline md:text-sm' onClick={() => {
              setExpandedReviews(prev => ({
                ...prev,
                [idx]: !prev[idx]
              }));
              // mixpanel tracking
              void (async () => {
                const mixpanelV2Client = (await import("services/mixpanelv2")).mixpanelV2Client;
                mixpanelV2Client.CLICK_REVIEW_SHOW_MORE({
                  propertyId: propertyId || "",
                  rating: review?.rating || 0
                });
              })();
            }}>
                      {isExpanded ? "Show less" : "Show more"}
                    </button>}
                </div>;
        })}
        </div>
        {reviews && reviews.length > 4 && <ReviewsModal ratingStarSum={ratingStarSum} property_id={propertyId} ratingPercentages={ratingPercentages} buttonText={`Show all ${propertyRatingUserCount} reviews`} buttonStyle='mt-4 h-7 px-0 text-sm bg-white font-semibold text-accent-500 underline mxd:mt-7 md:text-base' />}
      </div>
    </>;
};
export default Reviews;